import React, { useState, useMemo } from 'react';
import ReviewCard from './ReviewCard';

/**
 * ReviewGrid
 * Renders a responsive grid of ReviewCard with optional pagination via Show more.
 * Props:
 * - reviews: Array<Review>
 * - initialCount: number (default 9)
 * - step: number (default 9)
 * - className: string (optional wrapper classes)
 */
const ReviewGrid = ({ reviews = [], initialCount = 9, step = 9, className = '' }) => {
  const [visible, setVisible] = useState(initialCount);
  const total = reviews.length;
  const visibleItems = useMemo(() => reviews.slice(0, visible), [reviews, visible]);

  if (!Array.isArray(reviews) || reviews.length === 0) {
    return null;
  }

  return (
    <div className={className}>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
        {visibleItems.map((r, i) => (
          <ReviewCard key={i} review={r} />
        ))}
      </div>
      {visible < total && (
        <div className="mt-6 text-center">
          <button
            onClick={() => setVisible(v => Math.min(v + step, total))}
            className="inline-flex items-center px-6 py-3 rounded-full font-semibold shadow-md bg-gradient-to-r from-blue-600 to-purple-600 text-white hover:from-blue-700 hover:to-purple-700"
          >
            Show more reviews
          </button>
        </div>
      )}
    </div>
  );
};

export default ReviewGrid;


